export default "__VITE_ASSET__bFMy6nb___"